import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import qs from 'qs';
import { api } from '.';
import { handleRequestError } from '../utils/request'; // Statistics: Page, Button

export var apiStatisticalevent = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            payload.hideErrToast = true;
            _context.prev = 1;
            _context.next = 4;
            return api.get("/analytics/collect?".concat(qs.stringify(payload)));

          case 4:
            res = _context.sent;
            return _context.abrupt("return", [res.data]);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", handleRequestError(_context.t0, payload));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));

  return function apiStatisticalevent(_x) {
    return _ref.apply(this, arguments);
  };
}(); // query statistics info: Page, Button

export var apiQueryStatisticalEventDetailInfo = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            payload.hideErrToast = true;
            _context2.prev = 1;
            _context2.next = 4;
            return api.get("/admin/analytics?".concat(qs.stringify(payload)));

          case 4:
            res = _context2.sent;
            return _context2.abrupt("return", [res.data]);

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](1);
            return _context2.abrupt("return", handleRequestError(_context2.t0, payload));

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 8]]);
  }));

  return function apiQueryStatisticalEventDetailInfo(_x2) {
    return _ref2.apply(this, arguments);
  };
}();